import { useStore } from "@state/store";
import { useEffect } from "react";
import styled from "styled-components/macro";
import TheLocationFeature from "@common/features/TheLocation/TheLocation";
import { useCanvasStore } from "@state/canvasStore";
import { CAM_POSITION_INDEX } from "@data/cameraData";

const TheLocation = ({ children }) => {
  const setCameraData = useCanvasStore((s) => s.setCameraData);

  useEffect(() => {
    setCameraData(CAM_POSITION_INDEX["start"]);
  }, []);

  return (
    <Wrapper>
      <TheLocationFeature />
    </Wrapper>
  );
};

export default TheLocation;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: var(--primary);
`;
